import AdviceCard from './AdviceCard';

export default AdviceCard;
